// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: calc(100vh - 100px);
  flex-direction: row;
  background-color: white;
  overflow: hidden;
}

.brover-configuration-filter {
  width: 265px;
  background-color: #e8e8e8;
  box-sizing: border-box;
  color: black;
  display: flex;
  flex-direction: column;
}
.brover-configuration-filter .content-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.brover-configuration-filter .content-body__title {
  height: 50px;
  background-color: white;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
}
.brover-configuration-filter .content-body__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
}

.brover-order-table {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}
.brover-order-table img {
  border-radius: 50px;
}
.brover-order-table .article-item {
  cursor: pointer;
}
.brover-order-table .shopping-card {
  background-color: var(--color-surface);
  overflow-y: auto;
  z-index: 2;
  box-shadow: var(--shadow-lg);
  transition: top 0.25s ease 0s;
  top: calc(100vh - 180px);
  padding: var(--space-4) var(--space-5);
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  flex-direction: column;
  border-top: 1px solid var(--color-border);
  box-sizing: border-box;
}
.brover-order-table .shopping-card .summary {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
}
.brover-order-table .shopping-card .summary__row {
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--space-5);
  min-width: 0;
  flex-wrap: wrap;
}
.brover-order-table .shopping-card .summary__title {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text);
  flex: 0 0 auto;
}
.brover-order-table .shopping-card .summary__count {
  color: var(--color-text-muted);
  font-size: 14px;
  flex: 0 0 auto;
}
.brover-order-table .shopping-card .summary__total {
  flex: 1 1 auto;
  color: var(--color-text-muted);
  font-size: 14px;
  white-space: nowrap;
}
.brover-order-table .shopping-card .summary__total-value {
  font-weight: 700;
  color: var(--color-text);
  font-size: 16px;
  margin-left: var(--space-1);
}
.brover-order-table .shopping-card .summary__actions {
  display: flex;
  flex-direction: row;
  gap: var(--space-3);
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 0 1 auto;
  min-width: 0;
}
.brover-order-table .shopping-card .summary__actions > .brover-confirm-button {
  white-space: nowrap;
}
.brover-order-table .shopping-card.opened {
  top: 90px;
}
.brover-order-table__search {
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 var(--space-4);
  background-color: var(--color-surface);
  transition: background-color 120ms ease, box-shadow 120ms ease;
}
.brover-order-table__search:focus-within {
  background-color: var(--color-surface-muted);
}
.brover-order-table__groups {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
  background-color: var(--color-surface-muted);
  color: var(--color-text);
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  box-sizing: border-box;
}
.brover-order-table__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  position: relative;
}

.filter-item {
  margin-bottom: 20px;
  color: gray;
}
.filter-item__title {
  color: #3a3a3a;
  font-weight: 500;
  margin-bottom: 10px;
}
.filter-item__content {
  display: flex;
  flex-direction: row;
}
.filter-item__content__column {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-right: 10px;
  font-size: 11px;
  -webkit-user-select: none;
          user-select: none;
}
.filter-item__content__column mat-checkbox {
  margin-bottom: 5px;
}
.filter-item__content__column:last-child {
  margin-right: 0;
}

.test {
  height: 64px;
  width: 64px;
  margin-right: var(--space-3);
  text-decoration: none;
  color: var(--color-text-muted);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background-color: var(--color-surface);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.test:hover {
  border-color: var(--color-border-strong);
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
  color: var(--color-brand);
}
.test img {
  width: 80%;
  height: 80%;
  object-fit: contain;
  border: none !important;
  background-color: transparent;
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}
.test mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}

.search-icon {
  height: 24px;
  width: 24px;
  margin-right: var(--space-2);
  color: var(--color-text-muted);
  display: flex;
  justify-content: center;
  align-items: center;
}
.search-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.article-item {
  display: grid;
  grid-template-columns: 125px 125px 125px auto 90px 100px 50px;
  padding: var(--space-3) var(--space-6);
  border-bottom: 1px solid var(--color-border);
  -webkit-user-select: auto;
          user-select: auto;
  transition: background-color 120ms ease;
}
.article-item:hover {
  background-color: var(--color-brand-soft);
}
.article-item__column {
  margin-right: 15px;
  height: 75px;
  display: flex;
  align-items: center;
}
.article-item__column.code {
  font-size: 14px;
  font-weight: 500;
}
.article-item__column.descr {
  font-size: 12px;
}
.article-item__column.subgroup {
  padding-right: 30px;
  font-weight: bold;
}
.article-item__column.amount {
  margin: 0;
  width: 100%;
}
.article-item__column.amount input, .article-item__column.amount button {
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  outline: none;
}
.article-item__column.amount button {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cecece;
  font-size: 18px;
}
.article-item__column.amount input {
  border: none;
  width: 38px;
  border-bottom: 1px solid #cecece;
  border-top: 1px solid #cecece;
  text-align: center;
  outline: none;
}
.article-item__column.price {
  font-weight: 500;
  justify-content: center;
}
.article-item__column:last-child {
  margin-right: 0;
  justify-content: center;
}
.article-item__column:last-child mat-icon {
  cursor: pointer;
}

.group-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: auto;
  position: relative;
}
.group-wrapper .group-code {
  border-bottom: 1px solid #cecece;
  border-right: 1px solid #cecece;
}
.group-wrapper .group-code:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}
.group-wrapper .group-code__img {
  height: 200px;
  width: 225px;
  padding: 10px;
}
.group-wrapper .group-code__title {
  padding: 10px 20px;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
}

.group {
  padding: var(--space-3) var(--space-5);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--color-text-muted);
  border-right: 1px solid var(--color-border);
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease;
}
.group .sub {
  position: absolute;
  background-color: var(--color-surface);
  color: var(--color-text);
  z-index: 1000;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--space-4);
  left: 0;
  right: 0;
  top: 100%;
  height: 0;
  overflow: hidden;
  display: none;
  width: 100%;
}
.group .sub .reee {
  display: block;
  padding-bottom: var(--space-2);
  margin-bottom: var(--space-2);
  border-bottom: 1px solid var(--color-border);
  font-family: inherit;
  font-size: 14px;
}
.group:hover {
  background-color: var(--color-brand-soft);
  color: var(--color-brand);
}
.group:hover .sub {
  height: auto;
  display: block;
}

.reeeeeeeee {
  text-transform: lowercase;
}
.reeeeeeeee::first-letter {
  text-transform: uppercase !important;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/place-order/configurate/configurate.component.sass"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AACA;EACE,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAEF;AAAE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;AAEJ;AAAI;EACE,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAEN;AAAI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;AAEN;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,kBAAA;AAGF;AADE;EACE,mBAAA;AAGJ;AADE;EACE,eAAA;AAGJ;AAFE;EACE,sCAAA;EACA,gBAAA;EACA,UAAA;EACA,4BAAA;EACA,6BAAA;EACA,wBAAA;EACA,sCAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,yCAAA;EACA,sBAAA;AAIJ;AAFI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAIN;AAFM;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAIR;AAFM;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;AAIR;AAFM;EACE,8BAAA;EACA,eAAA;EACA,cAAA;AAIR;AAFM;EACE,cAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AAIR;AAFM;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,2BAAA;AAIR;AAFM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AAIR;AAFQ;EACE,mBAAA;AAIV;AAFI;EACE,SAAA;AAIN;AAFE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sCAAA;EACA,8DAAA;AAIJ;AAFI;EACE,4CAAA;AAIN;AAFE;EACE,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,WAAA;EACA,4CAAA;EACA,wBAAA;EACA,yCAAA;EACA,4CAAA;EACA,sBAAA;AAIJ;AADE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;AAGJ;;AAEA;EACE,mBAAA;EACA,WAAA;AACF;AACE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACE;EACE,aAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACN;AACM;EACE,kBAAA;AACR;AACM;EACE,eAAA;AACR;;AACA;EACE,YAAA;EACA,WAAA;EACA,4BAAA;EACA,qBAAA;EACA,8BAAA;EACA,+BAAA;EACA,qCAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gFAAA;AAEF;AAAE;EACE,wCAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AAEJ;AAAE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;AAEJ;AAAE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAEJ;;AAAA;EACE,YAAA;EACA,WAAA;EACA,4BAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGF;AADE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AADA;EACE,aAAA;EACA,6DAAA;EACA,sCAAA;EACA,4CAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uCAAA;AAIF;AAFE;EACE,yCAAA;AAIJ;AAFE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAIJ;AAFI;EACE,eAAA;EACA,gBAAA;AAIN;AAFI;EACE,eAAA;AAIN;AAFI;EACE,mBAAA;EACA,iBAAA;AAIN;AAFI;EACE,SAAA;EACA,WAAA;AAIN;AAFM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AAIR;AAFM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAIR;AAFM;EACE,YAAA;EACA,WAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AAIR;AAFI;EACE,gBAAA;EACA,uBAAA;AAIN;AAFI;EACE,eAAA;EACA,uBAAA;AAIN;AAFM;EACE,eAAA;AAIR;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAKF;AAHE;EACE,gCAAA;EACA,+BAAA;AAKJ;AAHI;EACE,yBAAA;EACA,eAAA;AAKN;AAHI;EACE,aAAA;EACA,YAAA;EACA,aAAA;AAKN;AAHI;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;AAKN;;AAFA;EACE,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,2CAAA;EACA,eAAA;EACA,yDAAA;AAKF;AAHE;EACE,kBAAA;EACA,sCAAA;EACA,wBAAA;EACA,aAAA;EACA,4BAAA;EACA,qCAAA;EACA,+BAAA;EACA,uBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAKJ;AAHI;EACE,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4CAAA;EACA,oBAAA;EACA,eAAA;AAKN;AAHE;EACE,yCAAA;EACA,yBAAA;AAKJ;AAHI;EACE,YAAA;EACA,cAAA;AAKN;;AAHA;EACE,yBAAA;AAMF;AAJE;EACE,oCAAA;AAMJ","sourcesContent":["\\:host\n  display: flex\n  height: calc(100vh - 100px)\n  flex-direction: row\n  background-color: white\n  overflow: hidden\n\n.brover-configuration-filter\n  width: 265px\n  background-color: #e8e8e8\n  box-sizing: border-box\n  color: black\n  display: flex\n  flex-direction: column\n\n  .content-body\n    flex: 1\n    display: flex\n    flex-direction: column\n\n    &__title\n      height: 50px\n      background-color: white\n      box-sizing: border-box\n      padding: 0 20px\n      display: flex\n      align-items: center\n      font-size: 18px\n      font-weight: 500\n\n    &__body\n      padding: 20px\n      display: flex\n      flex-direction: column\n      flex: 1\n      overflow: auto\n      box-sizing: border-box\n      width: 100%\n\n.brover-order-table\n  display: flex\n  flex-direction: column\n  flex: 1\n  position: relative\n\n  img\n    border-radius: 50px\n\n  .article-item\n    cursor: pointer\n  .shopping-card\n    background-color: var(--color-surface)\n    overflow-y: auto\n    z-index: 2\n    box-shadow: var(--shadow-lg)\n    transition: top 0.25s ease 0s\n    top: calc(100vh - 180px)\n    padding: var(--space-4) var(--space-5)\n    display: flex\n    bottom: 0\n    left: 0\n    right: 0\n    flex-direction: column\n    border-top: 1px solid var(--color-border)\n    box-sizing: border-box  // include padding in the width so left:0/right:0 don't overflow\n\n    .summary\n      display: flex\n      flex-direction: row\n      justify-content: flex-end\n      align-items: center\n      gap: var(--space-3)\n      min-width: 0\n\n      &__row\n        display: flex\n        flex-direction: row\n        flex: 1 1 auto\n        align-items: center\n        gap: var(--space-5)\n        min-width: 0  // let children shrink instead of forcing overflow\n        flex-wrap: wrap  // wrap actions to a second line on narrow viewports\n\n      &__title\n        font-size: 18px\n        font-weight: 700\n        color: var(--color-text)\n        flex: 0 0 auto\n\n      &__count\n        color: var(--color-text-muted)\n        font-size: 14px\n        flex: 0 0 auto\n\n      &__total\n        flex: 1 1 auto\n        color: var(--color-text-muted)\n        font-size: 14px\n        white-space: nowrap\n\n      &__total-value\n        font-weight: 700\n        color: var(--color-text)\n        font-size: 16px\n        margin-left: var(--space-1)\n\n      &__actions\n        display: flex\n        flex-direction: row\n        gap: var(--space-3)\n        align-items: center\n        flex-wrap: wrap\n        justify-content: flex-end\n        flex: 0 1 auto\n        min-width: 0\n\n        > .brover-confirm-button\n          white-space: nowrap\n\n    &.opened\n      top: 90px\n\n  &__search\n    height: 56px\n    display: flex\n    align-items: center\n    padding: 0 var(--space-4)\n    background-color: var(--color-surface)\n    transition: background-color 120ms ease, box-shadow 120ms ease\n\n    &:focus-within\n      background-color: var(--color-surface-muted)\n\n  &__groups\n    position: relative  // positioning context for the dropdown panels\n    display: flex\n    align-items: stretch\n    width: 100%\n    background-color: var(--color-surface-muted)\n    color: var(--color-text)\n    border-top: 1px solid var(--color-border)\n    border-bottom: 1px solid var(--color-border)\n    box-sizing: border-box\n\n\n  &__body\n    display: flex\n    flex-direction: column\n    flex: 1\n    overflow: auto\n    position: relative\n\n\n\n\n.filter-item\n  margin-bottom: 20px\n  color: gray\n\n  &__title\n    color: #3a3a3a\n    font-weight: 500\n    margin-bottom: 10px\n\n  &__content\n    display: flex\n    flex-direction: row\n\n    &__column\n      display: flex\n      flex: 1\n      flex-direction: column\n      margin-right: 10px\n      font-size: 11px\n      user-select: none\n\n      mat-checkbox\n        margin-bottom: 5px\n\n      &:last-child\n        margin-right: 0\n\n.test\n  height: 64px\n  width: 64px\n  margin-right: var(--space-3)\n  text-decoration: none\n  color: var(--color-text-muted)\n  border-radius: var(--radius-md)\n  border: 1px solid var(--color-border)\n  background-color: var(--color-surface)\n  display: flex\n  align-items: center\n  justify-content: center\n  cursor: pointer\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease\n\n  &:hover\n    border-color: var(--color-border-strong)\n    box-shadow: var(--shadow-sm)\n    transform: translateY(-1px)\n    color: var(--color-brand)\n\n  img\n    width: 80%\n    height: 80%\n    object-fit: contain\n    border: none !important\n    background-color: transparent\n    user-select: none\n    -webkit-user-drag: none\n\n  mat-icon\n    font-size: 22px\n    width: 22px\n    height: 22px\n\n.search-icon\n  height: 24px\n  width: 24px\n  margin-right: var(--space-2)\n  color: var(--color-text-muted)\n  display: flex\n  justify-content: center\n  align-items: center\n\n  mat-icon\n    font-size: 20px\n    width: 20px\n    height: 20px\n\n.article-item\n  display: grid\n  grid-template-columns: 125px 125px 125px auto 90px 100px 50px\n  padding: var(--space-3) var(--space-6)\n  border-bottom: 1px solid var(--color-border)\n  user-select: auto\n  transition: background-color 120ms ease\n\n  &:hover\n    background-color: var(--color-brand-soft)\n\n  &__column\n    margin-right: 15px\n    height: 75px\n    display: flex\n    align-items: center\n\n    &.code\n      font-size: 14px\n      font-weight: 500\n\n    &.descr\n      font-size: 12px\n\n    &.subgroup\n      padding-right: 30px\n      font-weight: bold\n\n    &.amount\n      margin: 0\n      width: 100%\n\n      input, button\n        width: 100%\n        height: 30px\n        box-sizing: border-box\n        outline: none\n\n      button\n        width: 40px\n        display: flex\n        justify-content: center\n        align-items: center\n        border: 1px solid #cecece\n        font-size: 18px\n\n      input\n        border: none\n        width: 38px\n        border-bottom: 1px solid #cecece\n        border-top: 1px solid #cecece\n        text-align: center\n        outline: none\n\n    &.price\n      font-weight: 500\n      justify-content: center\n\n    &:last-child\n      margin-right: 0\n      justify-content: center\n\n      mat-icon\n        cursor: pointer\n\n.group-wrapper\n  display: flex\n  flex-direction: row\n  flex-wrap: wrap\n  overflow: auto\n  position: relative\n\n  .group-code\n    border-bottom: 1px solid #cecece\n    border-right: 1px solid #cecece\n\n    &:hover\n      background-color: #f4f4f4\n      cursor: pointer\n\n    &__img\n      height: 200px\n      width: 225px\n      padding: 10px\n\n    &__title\n      padding: 10px 20px\n      font-weight: bold\n      user-select: none\n\n\n.group\n  padding: var(--space-3) var(--space-5)\n  font-size: 14px\n  font-weight: 500\n  letter-spacing: 0.02em\n  color: var(--color-text-muted)\n  border-right: 1px solid var(--color-border)\n  cursor: pointer\n  transition: background-color 120ms ease, color 120ms ease\n\n  .sub\n    position: absolute\n    background-color: var(--color-surface)\n    color: var(--color-text)\n    z-index: 1000\n    box-shadow: var(--shadow-lg)\n    border: 1px solid var(--color-border)\n    border-radius: var(--radius-md)\n    padding: var(--space-4)\n    left: 0\n    right: 0\n    top: 100%\n    height: 0\n    overflow: hidden\n    display: none\n    width: 100%\n\n    .reee\n      display: block\n      padding-bottom: var(--space-2)\n      margin-bottom: var(--space-2)\n      border-bottom: 1px solid var(--color-border)\n      font-family: inherit\n      font-size: 14px\n\n  &:hover\n    background-color: var(--color-brand-soft)\n    color: var(--color-brand)\n\n    .sub\n      height: auto\n      display: block\n\n.reeeeeeeee\n  text-transform: lowercase\n\n  &::first-letter\n    text-transform: uppercase !important\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
